import styled from 'styled-components';

export const ArrowButtonEnable = styled.div<{}>`
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  padding: 4px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.grayCC};
  }
`;

export const ArrowButtonDisable = styled.div<{}>`
  display: flex;
  padding: 4px;
`;
